module.exports = __webpack_public_path__ + "img/operator3.8a109596.png";